/* MedicLab supplement PDP — buy box, gallery, sticky bar.
   Plain ES5-ish, no dependencies, no browser storage.
   The form is a real POST to /cart/add so the page still works with JS off.

   Checkout routing is NOT in this file. "Buy it now" (data-mlx-buy-now) and
   every Check out button for these products are sent to Shopify's native
   checkout by snippets/mlx-native-checkout.liquid, which loads in <head>
   ahead of the TagadaPay mapper and covers every page, not just this one. */
(function () {
  'use strict';

  function $(sel, root) { return (root || document).querySelector(sel); }
  function $$(sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); }

  function money(cents, format) {
    var n = (cents / 100);
    var s = n.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return (format || '${{amount}}').replace(/\{\{\s*amount\s*\}\}/, s).replace(/\{\{\s*amount_no_decimals\s*\}\}/, String(Math.round(n)));
  }

  function initBuyBox(root) {
    var form = $('[data-mlx-form]', root);
    if (!form) return;

    var moneyFormat = form.getAttribute('data-money-format') || '${{amount}}';
    var daysPerUnit = parseInt(form.getAttribute('data-days-per-unit') || '30', 10);
    var idInput = $('[data-mlx-variant-id]', form);
    var plans = $$('[data-mlx-plan]', form);
    var freq = $('[data-mlx-freq]', form);
    var freqSelect = freq ? $('select', freq) : null;
    var qtyInput = $('[data-mlx-qty]', form);
    var ctaPrice = $$('[data-mlx-cta-price]', root);
    var ctaLabel = $$('[data-mlx-cta-label]', document);
    var perDayOut = $$('[data-mlx-perday]', root);
    var stickyPrice = $('[data-mlx-sticky-price]', document);

    function selected() {
      for (var i = 0; i < plans.length; i++) { if (plans[i].checked) return plans[i]; }
      return plans[0];
    }

    function sync() {
      var p = selected();
      if (!p) return;
      var isSub = p.getAttribute('data-sub') === 'true';
      var unit = parseInt(p.getAttribute('data-price') || '0', 10);
      var qty = Math.max(1, parseInt((qtyInput && qtyInput.value) || '1', 10) || 1);
      var total = unit * qty;

      if (idInput) idInput.value = p.getAttribute('data-variant-id') || '';

      if (freq) {
        freq.classList.toggle('is-on', isSub);
        if (freqSelect) freqSelect.disabled = !isSub;
      }

      ctaPrice.forEach(function (el) { el.textContent = money(total, moneyFormat); });
      ctaLabel.forEach(function (el) { el.textContent = p.getAttribute('data-cta') || 'Add to cart'; });
      if (stickyPrice) stickyPrice.textContent = money(total, moneyFormat);

      perDayOut.forEach(function (el) {
        if (!daysPerUnit) { el.textContent = ''; return; }
        el.textContent = money(Math.round(unit / daysPerUnit), moneyFormat);
      });
    }

    plans.forEach(function (p) { p.addEventListener('change', sync); });
    if (qtyInput) qtyInput.addEventListener('change', sync);

    $$('[data-mlx-qty-step]', form).forEach(function (btn) {
      btn.addEventListener('click', function () {
        if (!qtyInput) return;
        var step = parseInt(btn.getAttribute('data-mlx-qty-step'), 10);
        var v = Math.max(1, (parseInt(qtyInput.value, 10) || 1) + step);
        qtyInput.value = v;
        var minus = $('[data-mlx-qty-step="-1"]', form);
        if (minus) minus.disabled = v <= 1;
        sync();
      });
    });
    var minusBtn = $('[data-mlx-qty-step="-1"]', form);
    if (minusBtn) minusBtn.disabled = (parseInt(qtyInput && qtyInput.value, 10) || 1) <= 1;

    $$('[data-mlx-sticky-submit]').forEach(function (b) {
      b.addEventListener('click', function (e) {
        e.preventDefault();
        if (typeof form.requestSubmit === 'function') form.requestSubmit();
        else form.submit();
      });
    });

    /* Add to cart via AJAX so the theme's cart drawer opens (it listens for
       the cart:update event and morphs the sections we ask /cart/add for).
       Any failure falls back to the plain POST, which lands on /cart. */
    form.addEventListener('submit', function (e) {
      if (form.getAttribute('data-mlx-plain') === '1') return;
      if (!window.fetch || !window.FormData) return;
      var drawer = document.querySelector('cart-drawer-component');
      if (!drawer) return;
      e.preventDefault();
      var btn = $('button[type="submit"]', form);
      var sections = [];
      try { document.dispatchEvent(new CustomEvent('cart:grouped-sections', { detail: { sections: sections } })); } catch (err) {}
      var fd = new FormData(form);
      fd.delete('return_to');
      var uniq = sections.filter(function (s, i) { return sections.indexOf(s) === i; });
      if (uniq.length) fd.append('sections', uniq.join(','));
      var id = String(fd.get('id') || '');
      var qty = parseInt(fd.get('quantity'), 10) || 1;
      if (btn) { btn.disabled = true; btn.classList.add('is-busy'); }
      fetch('/cart/add.js', { method: 'POST', body: fd, headers: { 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' } })
        .then(function (r) { return r.json(); })
        .then(function (res) {
          if (btn) { btn.disabled = false; btn.classList.remove('is-busy'); }
          if (res && res.status) { throw new Error(res.description || res.message || 'Could not add to cart'); }
          document.dispatchEvent(new CustomEvent('cart:update', { bubbles: true, detail: {
            resource: res, sourceId: form.getAttribute('id') || 'mlx-form',
            data: { source: 'product-form-component', itemCount: qty, isIncremental: true, variantId: id, sections: res && res.sections }
          } }));
          try { document.dispatchEvent(new CustomEvent('product-ajax:added', { detail: { product: res } })); } catch (err) {}
          var live = $('[data-mlx-live]', form);
          if (live) live.textContent = 'Added to your cart';
        })
        .catch(function (err) {
          if (btn) { btn.disabled = false; btn.classList.remove('is-busy'); }
          var msg = $('[data-mlx-error]', form);
          if (msg) { msg.textContent = (err && err.message) || 'Something went wrong. Please try again.'; msg.hidden = false; }
          else { form.setAttribute('data-mlx-plain', '1'); form.submit(); }
        });
    });

    sync();
  }

  /* Gallery v2: scroll-snap track + thumbs, arrows, dots, counter, keyboard.
     Slides may come from section blocks and/or product media (see the hero
     section); this code only needs the data-mlx-gal-* hooks. */
  function initGallery(root) {
    var gal = $('[data-mlx-gallery]', root);
    if (!gal) return;
    var track = $('[data-mlx-gal-track]', gal);
    var slides = $$('[data-mlx-gal-slide]', gal);
    var thumbs = $$('[data-mlx-gal-thumb]', gal);
    var dots = $$('[data-mlx-gal-dots] i', gal);
    var counter = $('[data-mlx-gal-counter]', gal);
    var prev = $('[data-mlx-gal-prev]', gal);
    var next = $('[data-mlx-gal-next]', gal);
    var thumbRail = $('[data-mlx-gal-thumbs]', gal);
    if (!track || !slides.length) return;
    var n = slides.length;
    var cur = -1;

    function goTo(i, instant) {
      i = Math.max(0, Math.min(n - 1, i));
      var s = slides[i];
      if (!s) return;
      var left = s.offsetLeft - track.offsetLeft;
      if (instant || document.hidden || !('scrollBehavior' in document.documentElement.style)) track.scrollLeft = left;
      else track.scrollTo({ left: left, behavior: 'smooth' });
    }

    function mark() {
      var idx = Math.round(track.scrollLeft / Math.max(1, track.clientWidth));
      idx = Math.max(0, Math.min(n - 1, idx));
      if (idx === cur) return;
      cur = idx;
      thumbs.forEach(function (t, i) { t.setAttribute('aria-current', i === idx ? 'true' : 'false'); });
      dots.forEach(function (d, i) { d.classList.toggle('is-on', i === idx); });
      if (counter) counter.textContent = (idx + 1) + ' / ' + n;
      if (prev) prev.disabled = idx === 0;
      if (next) next.disabled = idx === n - 1;
      var t = thumbs[idx];
      if (t && thumbRail) {
        var tl = t.offsetLeft - thumbRail.offsetLeft, tr = tl + t.offsetWidth;
        if (tl < thumbRail.scrollLeft) thumbRail.scrollLeft = tl - 10;
        else if (tr > thumbRail.scrollLeft + thumbRail.clientWidth) thumbRail.scrollLeft = tr - thumbRail.clientWidth + 10;
      }
    }

    thumbs.forEach(function (t, i) { t.addEventListener('click', function () { goTo(i); }); });
    if (prev) prev.addEventListener('click', function () { goTo(cur - 1); });
    if (next) next.addEventListener('click', function () { goTo(cur + 1); });
    track.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowRight') { e.preventDefault(); goTo(cur + 1); }
      if (e.key === 'ArrowLeft') { e.preventDefault(); goTo(cur - 1); }
    });

    var timer = null;
    track.addEventListener('scroll', function () {
      if (timer) return;
      timer = setTimeout(function () { timer = null; mark(); }, 80);
    });
    window.addEventListener('resize', function () { if (cur >= 0) goTo(cur, true); });
    mark();
  }

  function initSticky(root) {
    var bar = $('[data-mlx-sticky]');
    var anchor = $('[data-mlx-cta-anchor]', root);
    if (!bar || !anchor || !('IntersectionObserver' in window)) return;
    new IntersectionObserver(function (entries) {
      entries.forEach(function (en) { bar.classList.toggle('is-on', !en.isIntersecting && en.boundingClientRect.top < 0); });
    }, { threshold: 0 }).observe(anchor);
  }

  /* Quote carousel (sections/mlx-pdp-quotes.liquid): one card at a time,
     swipe or arrows, dots, auto-advance that pauses on hover, focus and
     while the tab is hidden. Reduced-motion users get no auto-advance. */
  function initQuotes(root) {
    var qc = $('[data-mlx-qc]', root);
    if (!qc) return;
    var track = $('[data-mlx-qc-track]', qc);
    var slides = $$('[data-mlx-qc-slide]', qc);
    var dots = $$('[data-mlx-qc-dots] i', qc);
    var prev = $('[data-mlx-qc-prev]', qc);
    var next = $('[data-mlx-qc-next]', qc);
    if (!track || slides.length < 2) return;
    var n = slides.length, cur = 0, timer = null, paused = false;
    var interval = parseInt(qc.getAttribute('data-interval') || '6000', 10);
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    function goTo(i, instant) {
      i = ((i % n) + n) % n;
      cur = i;
      dots.forEach(function (d, k) { d.classList.toggle('is-on', k === i); });
      var s = slides[i];
      var left = s.offsetLeft - track.offsetLeft;
      if (instant || document.hidden || reduce || !('scrollBehavior' in document.documentElement.style)) track.scrollLeft = left;
      else track.scrollTo({ left: left, behavior: 'smooth' });
    }
    function mark() {
      var idx = Math.round(track.scrollLeft / Math.max(1, track.clientWidth));
      idx = Math.max(0, Math.min(n - 1, idx));
      cur = idx;
      dots.forEach(function (d, i) { d.classList.toggle('is-on', i === idx); });
    }
    function tick() {
      if (paused || document.hidden) return;
      goTo(cur + 1);
    }
    function start() { if (reduce || timer) return; timer = setInterval(tick, interval); }
    function stop() { if (timer) { clearInterval(timer); timer = null; } }

    if (prev) prev.addEventListener('click', function () { goTo(cur - 1); });
    if (next) next.addEventListener('click', function () { goTo(cur + 1); });
    track.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowRight') { e.preventDefault(); goTo(cur + 1); }
      if (e.key === 'ArrowLeft') { e.preventDefault(); goTo(cur - 1); }
    });
    var st = null;
    track.addEventListener('scroll', function () { if (st) return; st = setTimeout(function () { st = null; mark(); }, 80); });
    qc.addEventListener('mouseenter', function () { paused = true; });
    qc.addEventListener('mouseleave', function () { paused = false; });
    qc.addEventListener('focusin', function () { paused = true; });
    qc.addEventListener('focusout', function () { paused = false; });
    track.addEventListener('touchstart', function () { paused = true; }, { passive: true });
    track.addEventListener('touchend', function () { setTimeout(function () { paused = false; }, 4000); }, { passive: true });
    window.addEventListener('resize', function () { goTo(cur, true); });
    document.addEventListener('visibilitychange', function () { if (document.hidden) stop(); else start(); });
    mark();
    start();
  }

  function boot() {
    $$('[data-mlx-pdp]').forEach(function (root) {
      initBuyBox(root);
      initGallery(root);
      initSticky(root);
    });
    $$('[data-mlx-quotes]').forEach(initQuotes);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
